import { render, staticRenderFns } from "./Mentions.vue?vue&type=template&id=784b8f30&scoped=true"
import script from "./Mentions.vue?vue&type=script&lang=js"
export * from "./Mentions.vue?vue&type=script&lang=js"
import style0 from "./Mentions.vue?vue&type=style&index=0&id=784b8f30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784b8f30",
  null
  
)

export default component.exports